import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=63e6a9dd&scoped=true"
import script from "./svg-icon.vue?vue&type=script&lang=ts"
export * from "./svg-icon.vue?vue&type=script&lang=ts"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=63e6a9dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6a9dd",
  null
  
)

export default component.exports